/**
 * 색상 팔레트 정의
 * 각 팔레트는 primary, secondary, accent, background, surface, text, text-secondary를 포함
 */

export const colorPalettes = {
  // 기본 인디고-핑크 테마
  default: {
    name: '기본 (인디고-핑크)',
    primary: '#6366f1',      // indigo-500
    secondary: '#ec4899',    // pink-500
    accent: '#8b5cf6',       // purple-500
    background: '#f8fafc',   // slate-50
    surface: '#ffffff',      // white
    text: '#1e293b',         // slate-800
    textSecondary: '#64748b', // slate-500
  },
  
  // 오션 블루 테마
  ocean: {
    name: '오션 블루',
    primary: '#0ea5e9',      // sky-500
    secondary: '#06b6d4',    // cyan-500
    accent: '#3b82f6',       // blue-500
    background: '#f0f9ff',   // sky-50
    surface: '#ffffff',
    text: '#0c4a6e',         // sky-900
    textSecondary: '#0284c7', // sky-600
  },
  
  // 포레스트 그린 테마
  forest: {
    name: '포레스트 그린',
    primary: '#10b981',      // emerald-500
    secondary: '#059669',    // emerald-600
    accent: '#34d399',       // emerald-400
    background: '#ecfdf5',   // emerald-50
    surface: '#ffffff',
    text: '#064e3b',         // emerald-900
    textSecondary: '#047857', // emerald-700
  },
  
  // 선셋 오렌지 테마
  sunset: {
    name: '선셋 오렌지',
    primary: '#f97316',      // orange-500
    secondary: '#ef4444',    // red-500
    accent: '#fb923c',       // orange-400
    background: '#fff7ed',   // orange-50
    surface: '#ffffff',
    text: '#7c2d12',         // orange-900
    textSecondary: '#c2410c', // orange-700
  },
  
  // 퍼플 드림 테마
  purple: {
    name: '퍼플 드림',
    primary: '#a855f7',       // purple-500
    secondary: '#9333ea',    // purple-600
    accent: '#c084fc',       // purple-400
    background: '#faf5ff',   // purple-50
    surface: '#ffffff',
    text: '#581c87',         // purple-900
    textSecondary: '#7e22ce', // purple-700
  },
  
  // 다크 모드 테마
  dark: {
    name: '다크 모드',
    primary: '#818cf8',      // indigo-400
    secondary: '#f472b6',    // pink-400
    accent: '#a78bfa',       // violet-400
    background: '#0f172a',   // slate-900
    surface: '#1e293b',      // slate-800
    text: '#f1f5f9',         // slate-100
    textSecondary: '#cbd5e1', // slate-300
  },
  
  // 민트 프레시 테마
  mint: {
    name: '민트 프레시',
    primary: '#14b8a6',      // teal-500
    secondary: '#06b6d4',    // cyan-500
    accent: '#2dd4bf',       // teal-400
    background: '#f0fdfa',   // teal-50
    surface: '#ffffff',
    text: '#134e4a',         // teal-900
    textSecondary: '#0d9488', // teal-600
  },
  
  // 로즈 골드 테마
  roseGold: {
    name: '로즈 골드',
    primary: '#e11d48',      // rose-600
    secondary: '#f59e0b',    // amber-500
    accent: '#fb7185',       // rose-400
    background: '#fff1f2',   // rose-50
    surface: '#ffffff',
    text: '#881337',         // rose-900
    textSecondary: '#be123c', // rose-700
  },
};

/**
 * CSS 변수로 색상 팔레트 적용
 */
export const applyColorPalette = (palette) => {
  const root = document.documentElement;
  root.style.setProperty('--color-primary', palette.primary);
  root.style.setProperty('--color-secondary', palette.secondary);
  root.style.setProperty('--color-accent', palette.accent);
  root.style.setProperty('--color-background', palette.background);
  root.style.setProperty('--color-surface', palette.surface);
  root.style.setProperty('--color-text', palette.text);
  root.style.setProperty('--color-text-secondary', palette.textSecondary);
};
